<script setup lang="ts">
import Input from '@/components/ui/input/Input.vue'
import Dropdown from '@/components/ui/dropdown/Dropdown.vue'
import Button from '@/components/ui/button/Button.vue'
import { computed, inject, ref, watch } from 'vue'
import { ExclusionZoneViewModel } from '../viewmodels/ExclusionZone.viewmodel'
import Breadcrumb from '@/components/ui/breadcrumb/Breadcrumb.vue'

const vm = inject<ExclusionZoneViewModel>('exclusion-zone-view-model')!

const title = computed(() =>
	vm.exclusionZone.value?.id ? 'Editar Zona de Exclusão' : 'Cadastrar Zona de Exclusão',
)

const crumbs = [
	{ name: 'Cadastro Zona de Exclusão', step: 1 },
	{ name: 'Definição da área', step: 2 },
]

const step = ref(1)

watch(vm.openForm, (value) => {
	if (value) vm.getMonitoredAreas()
})
</script>

<template>
	<section>
		<breadcrumb
			transform="none"
			class="mb-8"
			v-model="step"
			:crumbs="crumbs"
		/>
		<h1 class="text-H5">{{ title }}</h1>
		<div class="flex flex-col gap-4 mt-8">
			<Input
				label="nome*"
				type="text"
				v-model.number="vm.exclusionZone.value.name"
			/>
			<Input
				v-model="vm.exclusionZone.value.description"
				label="descrição*"
			/>

			<Dropdown
				v-if="vm.exclusionZone.value?.id === undefined"
				v-model="vm.exclusionZone.value.monitoredAreaId"
				label="fazenda/setor*"
				:options="vm.monitoredAreaOptions.value"
			/>
			<div
				class="flex flex-col gap-2"
				v-else
			>
				<label class="text-label">Fazenda/setor</label>
				<p class="text-s text-gray-dark">{{ vm.monitoredAreaName.value }}</p>
			</div>
		</div>

		<div class="flex gap-4 mt-8">
			<Button
				text="voltar"
				secondary
				:disabled="vm.fetching.value"
				class="w-1/2 justify-center"
				@click="() => (vm.openForm.value = false)"
			/>
			<Button
				text="avançar"
				:loading="vm.fetching.value"
				:disabled="!vm.isFormValid.value"
				class="w-1/2 justify-center"
				@click="() => vm.goToZonesPage()"
			/>
		</div>
	</section>
</template>

<style scoped>
section {
	padding: 50px 32px 0 50px;
}

:deep(.v-input) {
	align-items: center;
}
</style>
